import { atom } from 'jotai';

// サイドナビの開閉状態。ツールバーの開閉ボタンと SideNav 本体が共有する。
// 既定は開（従来どおり常時表示）。
export const sideNavOpenAtom = atom<boolean>(true);
